import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: "资深吃瓜群众",
    role: "社区活跃用户",
    quote: "51吃瓜爆料网的更新速度简直太快了，每次有什么大事发生，这里总是第一个有详细报道的。我已经推荐给身边所有爱吃瓜的朋友了！",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Asian%20person%20with%20confident%20expression%20clean%20sky%20blue%20background%20warm%20natural%20daylight%20editorial%20style%20photography%20modern%20casual%20look&width=400&height=500&seq=testimonial-01&orientation=portrait",
  },
  {
    id: 2,
    name: "匿名爆料人A",
    role: "独家信源",
    quote: "作为一个经常提供线索的爆料人，我选择51吃瓜爆料网是因为他们对信源的保护非常到位，而且发布的内容从不添油加醋，实事求是。",
    imageUrl: "https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20portrait%20with%20dramatic%20backlighting%20anonymous%20source%20concept%20noir%20style%20cinematic%20atmosphere%20warm%20amber%20rim%20light%20professional%20editorial%20photography&width=400&height=500&seq=testimonial-02&orientation=portrait",
  },
  {
    id: 3,
    name: "媒体从业者",
    role: "行业观察者",
    quote: "从专业角度来看，51吃瓜爆料网在娱乐资讯领域的深度和广度都达到了很高的水准。很多独家报道甚至领先于传统媒体。",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20journalist%20in%20modern%20newsroom%20setting%20warm%20ambient%20lighting%20clean%20sky%20blue%20background%20contemporary%20editorial%20style%20photography&width=400&height=500&seq=testimonial-03&orientation=portrait",
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const goNext = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const goPrev = () => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const t = testimonials[current];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900">
            网友热评 <span className="text-foreground-400">与爆料证言</span>
          </h2>
          <p className="mt-2 text-foreground-500 text-sm">看看吃瓜群众们怎么说</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 items-center">
          <div className="w-full lg:w-[40%]">
            <div className="rounded-[2rem] overflow-hidden bg-accent-100 aspect-[4/5] max-w-sm mx-auto lg:mx-0">
              <img
                src={t.imageUrl}
                alt={t.name}
                className="w-full h-full object-cover object-top"
                title={`${t.name} - ${t.role}`}
              />
            </div>
          </div>

          <div className="w-full lg:w-[60%] flex flex-col justify-center">
            <span className="text-xs text-foreground-400 font-medium mb-4 tracking-wider">（ 用户真实反馈 ）</span>
            <h3 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight mb-1">
              {t.name}
            </h3>
            <p className="text-lg md:text-2xl font-heading text-foreground-300 mb-8">{t.role}</p>
            <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 border-l-4 border-primary-300 pl-5 py-1">
              {t.quote}
            </blockquote>
            <p className="text-sm font-semibold text-foreground-800">&mdash; {t.name}</p>

            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={goPrev}
                className="w-10 h-10 rounded-full border-2 border-foreground-200 flex items-center justify-center text-foreground-500 hover:border-primary-400 hover:text-primary-500 transition-colors cursor-pointer"
                aria-label="上一条"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={goNext}
                className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-950 transition-colors cursor-pointer"
                aria-label="下一条"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="text-xs text-foreground-400 ml-2">
                {current + 1} / {testimonials.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}